<template>
  <section class="success">
    <popup-base
      v-show="wantToMakeOffer"
      class="popo md:pt-10 md:pb-4 w-full"
      @clickOnBackground="logState"
    >
      <div class="cardinal mr-auto ml-auto p-5">
        <div
          class="success-container h-full pt-6"
        >
          <div class="text-left flex pl-6 pr-6">
            <div
              class="text-c24 font-c7 w-4/5"
            >
              Modifier un fournisseur
            </div>
            <div class="w-1/5 flex justify-end">
              <icon
                :data="icons.fermer"
                height="30"
                width="30"
                class="cursor-pointer"
                original
                @click="fermer"
              />
            </div>
          </div>

          <div class="text-c18 font-c4 mt-6 bg-white p-6 pb-12">
            <div class="text-left text-c12">
              Type de fournisseur
            </div>
            <multiselect
              :option="optionType"
              :value-t="valueType"
              width="36%"
              background="white"
              class="mt-2"
              placeholder="Monture"
              @info="retourType"
            />

            <div class="text-left text-c12 mt-8">
              Intitulé
            </div>
            <inputo
              class="mt-2"
              placeholder="China la"
              @info="retourNom"
            />

            <div class="text-left text-c12 mt-8">
              Adresse
            </div>
            <inputo
              class="mt-2"
              placeholder="Chine"
              @info="retourAdresse"
            />

            <div class="text-left text-c12 mt-8">
              Téléphone
            </div>
            <inputo
              class="mt-2"
              type="number"
              @info="retourTelephone"
            />

            <div v-if="valueType === 'GENERAUX'">
              <div class="text-left text-c12 mt-8">
                Service
              </div>
              <inputo
                class="mt-2"
                placeholder="Vente d'accessoire de verre"
                @info="retourService"
              />
            </div>

            <div v-if="valueType === 'METIER'">
              <div class="text-left text-c12 mt-8">
                Délais de livraison de verres (EN JOUR)
              </div>
              <inputo
                class="mt-2"
                type="number"
                placeholder="30"
                @info="retourLivraison"
              />
            </div>

            <div class="text-left text-c12 mt-8">
              Compte séquestre (Montant)
            </div>
            <inputo
              class="mt-2"
              type="number"
              placeholder="4000"
              @info="retourSequestre"
            />

            <div
              v-if="error !== null"
              class="mt-6 text-red"
            >
              {{ error }}
            </div>
          </div>

          <div class="flex">
            <div class="w-full">
              <buton
                label="Enregistrer"
                radius="0px"
                height="55px"
                :charge="charge"
                @oga="continuer"
              />
            </div>
          </div>
        </div>
      </div>
    </popup-base>
  </section>
</template>

<script>
import PopupBase from '../helper/add/popupfat'
import buton from '../helper/add/button'
import ic_agence from '../../assets/icons/agenceGray.svg'
import fermer from '../../assets/icons/fermer.svg'
import inputo from '../helper/form/input'
import multiselect from '../helper/form/multiselect'

export default {
  name: 'Success',
  components: { PopupBase, buton, inputo, multiselect },

  props: {
    activation: {
      type: Boolean,
      default: false
    },
    donne: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      donnes: null,
      wantToMakeOffer: false,
      icons: {
        ic_agence,
        fermer
      },
      optionType: ['GENERAUX', 'METIER'],
      valueType: 'GENERAUX',
      telephone: '',
      nom: '',
      adresse: '',
      error: null,
      charge: false,
      sequestre: '',
      service: '',
      livraison: ''
    }
  },

  created() {
    this.wantToMakeOffer = this.activation
    this.valueType = this.type
  },

  methods: {
    fermer () {
      this.$emit('oga', false)
    },

    continuer (answer) {
      this.charge = true
      this.error = null
      if (this.nom.length > 0 && this.telephone.length > 0 && this.sequestre.length > 0 && this.adresse.length > 0) {
        this.$emit('oga', false)
        this.charge = false
      } else {
        this.charge = false
        this.error = 'Veuillez remplir les champs pour continuer'
      }
    },

    retourNom (answer) {
      this.nom = answer
    },

    logState (answer) {
      this.wantToMakeOffer = answer
      this.$emit('oga', false)
    },

    retourType (answer) {
      this.valueType = answer
    },

    retourAdresse (answer) {
      this.adresse = answer
    },

    retourTelephone (answer) {
      this.telephone = answer
    },

    retourSequestre (answer) {
      this.sequestre = answer
    },

    retourService (answer) {
      this.service = answer
    },

    retourLivraison (answer) {
      this.livraison = answer
    }
  }
}
</script>

<style lang="scss"  scoped>
    @import "../../assets/styles/sass/mixin";
    .success {
      z-index: 999;
    }
    .cardinal {
      width: 42%;
    }

    .success-container {
      font-family: $font-default;
      width: 100%;
      background-color: #F5F5F5;
      height: auto;
      margin: auto;
      border-radius: 12px;
    }
    @media screen and (max-width: 700px){
      .success-container {
        width: 100%;
        height: 100vh;
      }
      .titre {
        font-size: 18px;
      }
      .bloc1 {
        width: 100%;
      }
      .bloc2 {
        width: 100%;
        font-size: 18px;
      }
      .button {
        width: 100%;
        font-size: 16px;
      }
      .cardinal {
        width: 100%;
      }
    }

    @media screen and (max-width: 1024px) and (min-width: 770px){
      .cardinal{
        width: 65%;
      }
      .titre{
        font-size: 18px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 19px;
      }
    }

    @media screen and (max-width: 769px) and (min-width: 701px){
      .cardinal{
        width: 90%;
      }
      .titre{
        font-size: 18px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 19px;
      }
    }
    @media screen and (max-width: 320px){
      .cardinal{
        width: 100%;
      }
      .titre{
        font-size: 14px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 15px;
      }
    }
</style>
